import classNames from 'classnames';
import { format as formatDate } from 'date-fns';
import { Accordion } from '~/components/Accordion/v2/Accordion';
import { BaseCard } from '~/components/Card';
import { ChallengeRewardHistory } from '~/components/Challenge/Purchase/ChallengePurchase.hooks';
import { DottedIndent } from '~/components/Icon';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { Pair } from '~/components/Pair';
import { format, formatBoost } from '~/components/Util/number';
import styles from './ChallengePurchaseItem.module.scss';

export type ChallengePurchaseItemProps = {
  className?: string;
} & ChallengeRewardHistory;

export const ChallengePurchaseItem = ({
  className,
  boost,
  name,
  purchaseAmount,
  purchaseAmountInUsd,
  purchaseCurrency,
  rewardAmount,
  rewardAssetType,
  thumbnailUrl,
  rewardAt,
}: ChallengePurchaseItemProps) => {
  const {
    citizenBoost,
    citizenLv2Count,
    citizenLv3Count,
    citizenLv4Count,
    petBoost,
    petCount,
    totalBoost,
  } = boost || {};

  return (
    <BaseCard color="muted" className={classNames(styles.root, className)} size="large">
      <p className={styles.date}>{formatDate(rewardAt, 'PP p')}</p>
      <img className={styles.thumbnail} alt="item" src={thumbnailUrl} width={54} />
      <div className={styles.content}>
        <p className={styles.itemName}>{name}</p>
        <Pair
          className={styles.pair}
          primaryPrice={purchaseAmount}
          primaryCurrency={purchaseCurrency}
          secondaryPrice={purchaseAmountInUsd}
          secondaryCurrency="USD"
        />
      </div>
      <div className={styles.don}>
        {format(rewardAmount)}
        {rewardAssetType}
      </div>
      <hr className={styles.divider} />
      <Accordion.Root className={styles.accordion}>
        {({ active }) => (
          <>
            <Accordion.Button
              variant="text"
              className={classNames(styles.accordionButton, { [styles.active]: active })}>
              <div className={styles.accordionButtonContent}>
                Boost(%)
                <p>{formatBoost(totalBoost)}%</p>
              </div>
            </Accordion.Button>
            <Accordion.Body className={styles.accordionBody}>
              <DescriptionList layout="horizontal" className={styles.list}>
                <dt>
                  <DescriptionList className={styles.sublist} layout="inline">
                    <DottedIndent className={styles.indentIcon} />
                    <dt>Lv2</dt>
                    <dd>
                      <strong>{format(citizenLv2Count)}</strong>
                    </dd>
                    <dt>Lv3</dt>
                    <dd>
                      <strong>{format(citizenLv3Count)}</strong>
                    </dd>
                    <dt>Lv4</dt>
                    <dd>
                      <strong>{format(citizenLv4Count)}</strong>
                    </dd>
                  </DescriptionList>
                </dt>
                <dd>{formatBoost(citizenBoost)}%</dd>
                <dt>
                  <DescriptionList className={styles.sublist} layout="inline">
                    <DottedIndent className={styles.indentIcon} />
                    <dt>Friends</dt>
                    <dd>
                      <strong>{format(petCount)}</strong>
                    </dd>
                  </DescriptionList>
                </dt>
                <dd>{formatBoost(petBoost)}%</dd>
              </DescriptionList>
            </Accordion.Body>
          </>
        )}
      </Accordion.Root>
    </BaseCard>
  );
};
